import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import {DataService} from '../services/data.service';

@Injectable()
export class StatementResolver implements Resolve<any> {
  constructor(private dataService: DataService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const statementId = route.paramMap.get('id').split('-')[0];
    return this.dataService.getStatement(statementId);
  }
}
